export default {
    NAO_PERMITE_SEM_PROCEDIMENTO:0,
    PERMITE_SEM_PROCEDIMENTO: 1
}